module.exports = __webpack_public_path__ + "img/img-aaf9ab64.66874f9e.png";